// extracted by mini-css-extract-plugin
export default {"container":"table_container__bIN5K","tableContainer":"table_tableContainer__TDFCf"};